// GENERATED BY ./src/scripts/generateComponents.ts
// DO NOT EDIT IT MANUALLY

import React from "react";

import { iconStataeusde } from "../../../icons/full/build/icon-stataeusde.icon";
import { IconComponentBaseProps } from "../../../utils";
import { Image } from "../../Base/Image";

const StataeusdeIcon = (props: IconComponentBaseProps) => {
  return <Image svgCode={iconStataeusde.data} {...props} />;
};

if (process.env.NODE_ENV !== 'production') {
  StataeusdeIcon.displayName = 'StataeusdeIcon';
}

export default StataeusdeIcon;